export default __webpack_public_path__ + "static/media/books-66.f0a7116c.jpg";